<template>
    <HeadlineComponent>Schichtplan</HeadlineComponent>
    <div class="mb-5" v-if="events.length > 1">
        <label for="event_select">Event Auswählen</label>
        <select id="event_select" v-model="event_id" class="form-control" @change="updateEvent()">
            <option>--- Auswählen ---</option>
            <option v-for="e of events" :key="e.id" :value="e.id">{{ e.name }}</option>
        </select>
    </div>
    <div v-for="team of teams" :key="team.id">
        <h2>
            {{ team.name }}<br />
            <small v-if="team.teamleads"><span v-for="teamlead of team.teamleads" :key="teamlead.id"
                    class="comma-after">{{ teamlead.full_name }}</span></small>
        </h2>
        <div class="row" v-for="(task, i) of team.tasks" :key="task.id">
            <template v-if="i % 3 === 0">
                <div class="col-sm mt-3" v-for="y of [0, 1, 2]" :key="y">
                    <template v-if="team.tasks[i + y]">
                        <h3>{{ team.tasks[i + y].name }}</h3>
                        <table class="table">
                            <tbody>
                                <tr v-for="shift of team.tasks[i + y].shifts" :key="shift.id">
                                    <td style="line-height: 0.8">
                                        {{ $filters.formatDate(shift.start, 'HH:mm') }} - {{
                                            $filters.formatDate(shift.end, 'HH:mm')
                                        }}<br />
                                        <small style="font-size: x-small">{{
                                            $filters.formatDate(shift.start,
                                                'DD.MM.YYYY')
                                        }} - {{
    $filters.formatDate(shift.end, 'DD.MM.YYYY')
}}</small>
                                    </td>
                                    <td v-if="shift.user" style="text-align: right">
                                        <span
                                            v-if="shift.reserved && (shift.reserved_first_name || shift.reserved.last_name)">{{
                                                shift.reserved_first_name
                                            }} {{ shift.reserved_last_name }}.</span>
                                        <span
                                            v-if="shift.reserved && (!shift.reserved_first_name && !shift.reserved.last_name)">Reserviert</span>
                                        <span v-if="!shift.reserved">{{ shift.user.full_name }}</span>
                                    </td>
                                    <td v-if="!shift.user" style="text-align: right">-</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import apiService from "@/services/api.service";
import * as Sentry from '@sentry/vue';

export default {
    name: "ApiShiftsView",
    components: { HeadlineComponent },
    data() {
        return {
            teams: [],
            events: [],
            event_id: "",
        }
    },
    async beforeRouteEnter(to, from, next) {
        let teams = {};
        let events = [];
        try {
            let response = await apiService.events(to.params.token);
            events = response.data;
            if (events.length) {
                response = await apiService.shifts(to.params.token, events[0].id);
                teams = response.data;
            }
        } catch (e) {
            if (e) {
                Sentry.captureException(e);
                useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
                window.scrollTo(0, 0);
            }
        }
        next(vm => {
            vm.teams = teams;
            vm.events = events;
            if (events.length) {
                vm.event_id = events[0].id;
            }
        })
    },
    methods: {
        ...mapActions(useAlertsStore, { addAlert: 'add' }),
        async updateEvent() {
            var response = await apiService.shifts(this.$route.params.token, this.event_id);
            this.teams = response.data;
        },
    }
}
</script>

<style scoped>
td {
    height: 48px;
    vertical-align: middle;
}
</style>